var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from 'vue';
import { Component, Watch } from "vue-property-decorator";
import axios from "axios";
import { isPast, parseJSON } from 'date-fns';
let JobList = class JobList extends Vue {
    id = this.$route.params.id;
    search = '';
    filter = [];
    jobs = [];
    loading = true;
    page = {
        total: 0
    };
    options = {
        itemsPerPage: 20,
        page: 1,
        total: 0
    };
    text = '';
    snackbar = false;
    timeout = 5000;
    color = "";
    pdf = new Blob();
    headers = [
        { text: 'Auftragsnummer', align: 'start', sortable: true, value: 'id' },
        { text: 'Ordernummer', sortable: true, value: 'order_nr', },
        { text: 'Artikel', sortable: true, value: 'article' },
        { text: 'Kunde', sortable: true, value: 'customer' },
        { text: 'Lieferdatum', sortable: true, value: 'delivery_date' },
        { text: 'Endkontrolle', sortable: true, value: 'final_control' },
        { text: 'index', sortable: true, value: 'index' },
        { text: 'Notiz', sortable: true, value: 'note' },
        { text: 'Aktionen', sortable: true, value: 'actions' },
    ];
    getJobList() {
        this.loading = true;
        this.setFilter('type', this.$attrs.type);
        this.setFilter('search', this.search);
        axios.get('/api/jobs', {
            params: {
                itemsPerPage: this.options.itemsPerPage,
                page: this.options.page,
                sortBy: this.options.sortBy.toString(),
                sortDesc: this.options.sortDesc,
                filter: this.filter,
            }
        }).then((response) => {
            this.jobs = response.data.data;
            this.page = response.data.meta;
            this.loading = false;
        });
        return this.jobs;
    }
    JobDelete(id) {
        if (confirm("Do you really want to delete?")) {
            axios.delete('/api/jobs/' + id).then(() => {
                //   this.getJobList;
                this.text = "Der Job wurde erfolgreich gelöscht";
                this.color = "success";
                this.snackbar = true;
            }).catch((error) => {
                this.text = "Der Job kann nicht gelöscht werden, denn eine Kopie des Auftrages existiert schon.";
                this.color = "red";
                this.snackbar = true;
            });
            this.snackbar = false;
        }
    }
    filterOnlyLowerText(value, search, item) {
        return value != null &&
            search != null &&
            typeof value === 'string' &&
            value.toString().toLocaleLowerCase().indexOf(search) !== -1;
    }
    printPDF(id) {
        let url = "http://" + window.location.hostname + "/jobs/" + id + "/pdf";
        window.open(url);
    }
    async copy(id) {
        if (confirm("Möchtest du wirklich den Auftrag Kopieren?")) {
            await axios.post('/api/jobs/' + id + '/copy', { id: id }).then((response) => {
                //  this.getJobList();
                this.text = "Der Auftrag wurde erfolgreich Kopiert";
                this.color = "success";
                this.snackbar = true;
            }).catch((error) => {
                this.text = "Der Auftrag kann nicht Kopiert werden";
                this.color = "red";
                this.snackbar = true;
            });
            this.snackbar = false;
            await this.getJobList();
        }
    }
    setFilter(key, value) {
        this.clearFilterByKey(key);
        if (value != -1 || value != '-1') {
            this.filter.push({ key: key, value: value });
        }
    }
    clearFilterByKey(key) {
        for (let i = 0; i < this.filter.length; i++) {
            if (this.filter[i].key == key) {
                this.filter.splice(i, 1);
            }
        }
        return false;
    }
    isPast(item) {
        return isPast(parseJSON(item));
    }
    watchOptions() {
        this.getJobList();
        this.$store.state.monitor = false;
    }
    watchSearch() {
        this.getJobList();
        this.$store.state.monitor = false;
    }
    mounted() {
        if (this.$store.getters.isLoggedIn) {
            this.getJobList();
            this.$store.state.monitor = false;
        }
        else {
            this.$store.commit('logout');
        }
    }
    userHasRole(role) {
        return this.$store.getters.userHasRole(role);
    }
};
__decorate([
    Watch('options', { deep: true }),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], JobList.prototype, "watchOptions", null);
__decorate([
    Watch('search'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], JobList.prototype, "watchSearch", null);
JobList = __decorate([
    Component({
        name: "JobList",
    })
], JobList);
export default JobList;
